'use client';
var classes = {"root":"m_dd3f7539","typographyStylesProvider":"m_d37966d9","content":"m_c2204cc2","linkEditorDropdown":"m_8a991b4f","control":"m_c2207da6","controlIcon":"m_9cdfeb3f","controlsGroup":"m_2ab47ef2","linkEditor":"m_b67b711e","linkEditorInput":"m_296cf94c","linkEditorExternalControl":"m_cfef614","linkEditorSave":"m_3b28e7bb","toolbar":"m_4574a3c4","taskList":"m_8b44009a"};

export { classes as default };
//# sourceMappingURL=RichTextEditor.module.css.mjs.map
